import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../css/Page.module.css";
import data from "../Data";
import toast from "react-hot-toast";

function Contact() {
  const [formData, setFormData] = useState({
    from: "",
    subject: "",
    information: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.from || !formData.subject || !formData.information) {
      toast.error("Please fill in all fields");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.from)) {
      toast.error("Please enter a valid email address");
      return;
    }

    // Create mailto link with form data
    const emailBody = `From: ${formData.from}\n\n${formData.information}`;
    const mailtoLink = `mailto:${data.Gmail}?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(emailBody)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message
    toast.success("Mail Sent!");
    
    // Reset form
    setFormData({
      from: "",
      subject: "",
      information: "",
    });
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <h1 className={styles.title}>Contact Us</h1>
        <p className={styles.text}>
          Get in touch with Serenade Festival to discuss your next event. We're here to help bring your vision to life.
        </p>
        
        <form onSubmit={handleSubmit} className={styles.bookingForm}>
          <div className={styles.formGroup}>
            <label htmlFor="from" className={styles.formLabel}>
              From:
            </label>
            <input
              type="email"
              id="from"
              name="from"
              value={formData.from}
              onChange={handleChange}
              className={styles.formInput}
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="subject" className={styles.formLabel}>
              Subject:
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className={styles.formInput}
              placeholder="Contact Inquiry"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="information" className={styles.formLabel}>
              Information:
            </label>
            <textarea
              id="information"
              name="information"
              value={formData.information}
              onChange={handleChange}
              className={styles.formTextarea}
              placeholder="Tell us about your inquiry, questions, or how we can help you..."
              rows="6"
              required
            />
          </div>

          <button type="submit" className={styles.sendButton}>
            Send
          </button>
        </form>

        <div className={styles.contactIcons}>
          <a
            className={styles.contactIconLink}
            href={`mailto:${data.Gmail}`}
            aria-label="Email Serenade"
            title="Email Serenade"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 7 9-7" />
            </svg>
          </a>
          <a
            className={styles.contactIconLink}
            href={`tel:${data.Phone.replace(/[^+\d]/g, "")}`}
            aria-label="Call Serenade"
            title="Call Serenade"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.05 2h3a2 2 0 0 1 2 1.72c.12.83.37 1.64.72 2.4a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6 6l1.68-1.41a2 2 0 0 1 2.11-.45c.76.35 1.57.6 2.4.72A2 2 0 0 1 22 16.92z" />
            </svg>
          </a>
          <a
            className={styles.contactIconLink}
            href={data.Instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4.3" />
              <circle cx="17" cy="7" r="1.2" fill="currentColor" stroke="none" />
            </svg>
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;

